import { PageRoute } from 'src/constants/constants';
import { ZERO_FEES_ACTIVE_MARKET_INDEXES } from 'src/constants/zeroFees';
import { useSwitchMarket } from 'src/hooks/driftActions/market/useSwitchMarket';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { useSyncLocalStorage } from 'src/hooks/useSyncLocalStorage';
import { MarketType } from '@velocity-exchange/sdk';
import { usePerpMarketsSortedByMarketIndex } from 'src/hooks/perpMarkets/usePerpMarketsSortedByMarketIndex';
import StatusBar from 'src/components/primitives/StatusBar/StatusBar';

export default function ZeroFeesBanner() {
	const { switchMarket } = useSwitchMarket();
	const isOnTradePage = useDriftStore(
		(s) => s.currentPageRoute === PageRoute.trade
	);
	const perpMarketsSortedByMarketIndex = usePerpMarketsSortedByMarketIndex();

	const [hasDismissedBanner, setHasDismissedBanner] = useSyncLocalStorage(
		`zero_fees_banner_dismissed_for_${ZERO_FEES_ACTIVE_MARKET_INDEXES.join(
			','
		)}`,
		false
	);

	const shouldShow =
		ZERO_FEES_ACTIVE_MARKET_INDEXES.length && !hasDismissedBanner;

	if (!shouldShow) {
		return null;
	}

	const handleClose = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		setHasDismissedBanner(true);
	};

	const handleClick = (marketIndex: number) => {
		switchMarket({
			marketIndex,
			marketType: MarketType.PERP,
			goToTradePage: !isOnTradePage,
		});
	};

	return (
		<StatusBar variant="announcement" onClose={handleClose}>
			Trade{' '}
			{ZERO_FEES_ACTIVE_MARKET_INDEXES.map((marketIndex, index) => {
				const market = perpMarketsSortedByMarketIndex.find(
					(m) => m.marketIndex === marketIndex
				);

				if (!market) {
					return null;
				}

				const isLast = index === ZERO_FEES_ACTIVE_MARKET_INDEXES.length - 1;
				const isSecondToLast =
					index === ZERO_FEES_ACTIVE_MARKET_INDEXES.length - 2;

				return (
					<span key={marketIndex}>
						<span
							className="cursor-pointer font-bold"
							onClick={() => handleClick(marketIndex)}
						>
							{market.baseAssetSymbol}
						</span>
						{!isLast && (
							<span>
								{isSecondToLast && ZERO_FEES_ACTIVE_MARKET_INDEXES.length > 1
									? ' and '
									: ', '}
							</span>
						)}
					</span>
				);
			})}{' '}
			with 0% fees!
		</StatusBar>
	);
}
